import { Theme } from '@mui/material';

export const styles = (theme: Theme) => {
  return {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: theme.custom.height['100vh'],
      width: theme.custom.width['100vw'],
    },
    loader: {
      color: 'secondary.main',
    },
  };
};
